import React, { useMemo } from 'react';
import { Table } from 'antd';
import { VList } from 'virtuallist-antd';

/**
 * Create an Ant table that is wrapped inside ResizeObserver
 * @param {Object} props takes Table props
 * @returns Table Component
 */
export function VirtualTable(props) {
    const { scroll } = props;

    const vComponents = useMemo(() => {
        return VList({
            height: scroll.y,
            resetTopWhenDataChange : false
        })
    }, [scroll.y])

    return (
        <Table
            {...props}
            components={vComponents}
        />
    );
}